export default {
  searchHnNamePhone: 'Search HN, patient name, phone number',
  patient: 'Patient',
  addPatient: 'Add new patient',
  seePatientInfo: 'View patient information',
  deleteConfirm: 'Confirm delete patient',
  deleteInfo1: 'You are deleting the patient',
  deleteInfo2: 'Do you want to continue?',
  openOpd: 'Open OPD',
  searchPatientName: 'Search patient name',
  symptom: 'Select symptom',
  title: {
    taxInfo: 'Tax invoice information',
    general: 'General information',
    healthInfo: 'Health information'
  },
  header: {
    historyPill: 'Medication history',
    historyCourse: 'Course usage history'
  },
  label: {
    peopleId: 'National ID number',
    passport: 'Passport number',
    certificateStatement: 'This is to certify that',
    peopleIdPassport: 'National ID/Passport number',
    patientNoRegistered: 'Patient not yet registered',
    name: 'Patient name',
    patientId: 'Patient ID',
    nameEn: 'Name (EN)',
    nameCn: 'Name (CN)',
    nickName: 'Nickname',
    quantity: 'Remaining quantity',
    birthDay: 'Date of birth',
    detailSendToPatient: 'Details (configured to be sent to the patient)',
    note: 'Note (not sent to the patient)',
    appointDay: 'Appointment date',
    appointmentPerson: 'Appointed person',
    timeStartAppoint: 'Start time',
    timeEndAppoint: 'End time',
    patientArrived: 'Patient arrived',
    patientArrivedYet: 'Patient not arrived',
    noti: 'Notification',
    notiFirst: 'Notify before',
    medicalCertificate: 'Medical certificate',
    treatmentCertificate: 'Treatment certificate',
    certificateNumber: 'Certificate number',
    InShort: 'In short',
    selectColor: 'Select color label',
    serviceList: 'Service list',
    serviceListAndCourse: 'Services and courses',
    nationality: 'Nationality',
    bloodType: 'Blood type',
    rightToTreatment: 'Health Benefits',
    rightToTreatmentName: 'Treatment right name',
    channelsToKnow: 'How did you know the clinic ?',
    contractChanal: 'Contact channel',
    congenitalDisease: 'Underlying disease',
    accidentAndSurgery: 'Accidents and surgeries',
    hospitalized: 'History of hospitalization',
    epilepsy: 'Epilepsy*',
    leprosyContagiousStage: 'Leprosy in a contagious or socially objectionable stage',
    tuberculosisDangerousStage: 'Tuberculosis in a dangerous stage',
    elephantiasisWithOffensiveSymptoms: 'Elephantiasis with socially objectionable symptoms',
    workRelatedDiseaseCheckRequired: 'If necessary, specify work-related disease examination',
    personCertification: 'This person is not physically disabled to the extent of incapacity, has no signs of insanity, intellectual disability, drug addiction, alcoholism, or any of the following diseases',
    statementCertification: 'I certify the above information is true',
    currentMedicine: 'Current medication',
    allergy: 'Drug allergy / allergic reactions',
    subAllergy: 'Subcategory of drug allergy',
    patientTag: 'Patient tag',
    tag: 'Tag',
    salesperson: 'Assigned salesperson',
    medicalAssistant: 'Assigned medical assistant',
    examinedPerson: 'Person examined',
    regularDoctor: 'Assigned doctor',
    contact: 'Contact info',
    relation: 'Relation',
    labelSettings: 'Label settings',
    next: 'Next',
    back: 'Back',
    type: 'Patient type',
    editType: 'Edit patient type',
    editTypeInfo: 'Edit patient type information',
    editDoctorType: 'Edit doctor type information',
    enterTypeInfo: 'Enter patient type information',
    statusApp: 'Appointment status',
    normal: 'Normal',
    abNormal: 'Abnormal'
  },
  placeholder: {
    nameCn: 'Enter Chinese name',
    nickName: 'Enter nickname',
    peopleId: 'Enter National ID number',
    passport: 'Enter passport number',
    selectBirthDay: 'Select date of birth',
    detailSendToPatient: 'Details (configured to be sent to the patient)',
    note: 'Note (not sent to the patient)',
    appointDay: 'Appointment date',
    appointmentPerson: 'Appointed person',
    timeStartAppoint: 'Start time',
    timeEndAppoint: 'End time',
    selectColor: 'Select desired color',
    selectService: 'Select service',
    serviceListAndCourse: 'Select services and courses',
    nationality: 'Enter nationality',
    bloodType: 'Select blood type',
    rightToTreatment: 'Select treatment right',
    rightToTreatmentName: 'Enter treatment right name',
    rightToTreatmentInfo: 'Enter treatment right information',
    searchRightToTreatmentName: 'Search treatment right name',
    channelsToKnow: 'Enter how you knew the clinic',
    congenitalDisease: 'Enter underlying disease',
    currentMedicine: 'Enter current medication details',
    allergy: 'Enter allergy or allergic reactions',
    patientTag: 'Enter patient tag',
    selectPatientTag: 'Select patient tag',
    salesperson: 'Select assigned salesperson',
    medicalAssistant: 'Select assigned medical assistant',
    regularDoctor: 'Select assigned doctor',
    contact: 'Enter contact info',
    enter: 'Enter',
    relation: 'Enter relation',
    searchTag: 'Search patient tag name',
    searchType: 'Search patient type name'
  },
  status: {
    noti: 'Notify',
    unoti: 'Do not notify',
    disableNoti: 'Disable notification',
    activateNoti: 'Enable notification',
    need: 'Required',
    noneed: 'Not required',
    haveMedicalCertificate: 'Has medical certificate',
    noHaveMedicalCertificate: 'No medical certificate'
  },
  alert: {
    plzEnterTel10: 'Please enter a 10-digit phone number',
    plzEnterPeopleId: 'Please enter a 13-digit national ID number',
    plzEnterCorrectPeopleId: 'Please enter a valid national ID number',
    emailValid: 'Please enter a valid email',
    availableIdUse: 'This national ID is already in use',
    rightToTreatmentDelete: 'Confirm delete treatment right',
    rightToTreatmentConfirm: 'You are deleting this treatment right. Do you want to continue?',
    plzPassport: 'Please enter a passport number',
    wrongPassport: 'Invalid passport number format'
  },
  toolTip: {
    patientInfo: 'Patient information',
    createPatientInfo: 'Create patient record',
    createPatientInfoSuc: 'Patient information created successfully',
    createRightToTreatment: 'Successfully created patient treatment right!',
    editPatientInfo: 'Edit patient information',
    editPatientInfoSuc: 'Patient information updated successfully',
    editRightToTreatment: 'Edit treatment right',
    editRightToTreatmentSuc: 'Patient treatment right updated successfully!',
    editPatientTag: 'Edit patient tag',
    deletePatientInfo: 'Delete patient information',
    deletePatientInfoSuc: 'Patient information deleted successfully',
    deleteRightToTreatment: 'Successfully deleted treatment right'
  },
  modal: {
    create: {
      tag: {
        success: 'Patient tag created successfully!'
      }
    },
    edit: {
      tag: {
        success: 'Tag updated successfully!'
      },
      type: {
        success: 'Patient type updated successfully!'
      }
    },
    delete: {
      tag: {
        title: 'Confirm delete tag',
        subTitle: 'You are deleting a tag. Do you want to continue?',
        success: 'Tag deleted successfully!'
      },
      type: {
        title: 'Confirm delete patient type',
        subTitle: 'You are deleting a patient type. Do you want to continue?',
        success: 'Patient type deleted successfully!'
      }
    }
  }
}
